/**
 * 📅 LA FECHA DEL CALENDARIO DEL USUARIO, NO LA DE GREENWICH
 *
 * `new Date().toISOString()` da SIEMPRE la fecha en UTC. Para alguien en
 * México (UTC-6) que exporta a las 19:00 del día 19, sale "2026-08-20": el
 * archivo se llama con el día siguiente al que lo generó.
 *
 * El truco es restar el desfase de la zona horaria antes de serializar, de modo
 * que el "día" que devuelve `toISOString()` sea el del reloj de quien mira la
 * pantalla. Es lo mismo que ya hacían por su cuenta el filtro de fechas de
 * `FormResponses` y el rango de `DatosFirestoreContext`; se junta aquí para que
 * no haya tres copias de la misma resta.
 *
 * ⚠️ Solo para la FECHA de calendario (nombres de archivo, valores de
 * `<input type="date">`, claves de agrupación por día). Para mostrar una fecha
 * y hora al usuario se usa `toLocaleString()`, que ya trabaja en local sin
 * ayuda de nadie.
 */

/**
 * 'aaaa-mm-dd' según el reloj del usuario.
 *
 * @param {Date} [fecha=new Date()]
 * @returns {string}
 */
export function fechaLocalISO(fecha = new Date()) {
  const desplazado = new Date(fecha.getTime() - fecha.getTimezoneOffset() * 60000);
  return desplazado.toISOString().slice(0, 10);
}
